<template>
  <div class="channel-item-container" @click="toDetail">
     <div class="cover">
        <img v-lazy="item.pic_url_list || item.pic_url" alt="">
      </div>
      <div class="channel-right">
        <h2 class="channel-title">{{item.title}}</h2>
      <div class="channel-amount" :class="{'update-all': item.has_update_all}">
        {{item.has_update_all ? `${item.amount}期全` : `更新至${item.amount}期`}}·{{item.count}}人开通
      </div>
      <div class="channel-activity">
         <div class="channel-price">{{item.activity.id ? (item.activity.sale_price || (+item.price - +item.activity.discount).toFixed(2)) : item.price}}</div>

         <img v-if="item.activity.id && item.activity.activity_type === 'limit_buy'" src="../../assets/icons/sale.png" alt="">
      </div>
      </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  methods: {
    toDetail() {
      this.$emit("toDetail", this.item)
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../../common.less");
.channel-item-container {
  display: flex;
  -webkit-text-size-adjust: auto;
  background: #ffffff;
  border-bottom: 1px solid #ededed;
  width: 100%;
  height: 6.18rem;
  margin-top: 1.41rem;
  @media only screen and (max-width: 320px) {
    // width: 16rem;
  }
  .channel-right {
    width: 15rem;
    padding: 0 0.71rem;
    .channel-amount {
      padding: 0.26rem 0 0.35rem 0;
      font-family: PingFangSC-Light;
      font-size: 0.71rem;
      color: #999999;
    }
    .channel-title {
      flex: 1;
      // height: 2.47rem;
      font-size: 0.88rem;
      color: @text1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .channel-activity {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .channel-price {
        font-size: 0.88rem;
        color: @commonColor;
      }
      img {
        .image-cover;
        width: 3.29rem;
      }
    }
  }
  .cover {
    // .display-flex;
    width: 5.29rem;
    height: 5.29rem;
    border-radius: 0.53rem;
    margin-left: 0.71rem;
    img {
      display: block;
      border-radius: 0.53rem;
      height: 5.29rem;
      width: 5.29rem;
    }
  }
}
</style>
